var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "guidePage"
  }, [_c('el-dialog', {
    attrs: {
      "visible": _vm.show,
      "close-on-click-modal": false,
      "append-to-body": true
    },
    on: {
      "update:visible": function ($event) {
        _vm.show = $event;
      },
      "close": _vm.changeVal
    }
  }, [_c('i', {
    staticClass: "el-icon-top"
  }), _c('img', {
    attrs: {
      "src": require("@/assets/img/guideImg.png"),
      "alt": "",
      "srcset": ""
    }
  }), _c('div', {
    staticClass: "guideText"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(" If you have a camera/mic, then it is blocked ")]), _c('p', {
    staticClass: "text"
  }, [_vm._v(" Party needs access to your camera/mic. To use Party. ")]), _c('ul', {
    staticClass: "step"
  }, [_c('li', [_vm._v(" Click the camera blocked icon "), _c('img', {
    staticClass: "noCameraImg",
    attrs: {
      "src": require("@/assets/img/noCamera.png")
    }
  }), _vm._v(" in your browser's address bar ")]), _c('li', [_vm._v(" Click \"manage\" button to jump to browser setting page ")]), _c('li', [_vm._v(" Allow camera/microphone access and then go back to Partyline and refresh the page ")])])])])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };